import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
    margin: ${themeGet('margin.standard')};
    width: fill-available;

    border: ${themeGet('border.standard.color')} solid
        ${themeGet('border.standard.size')};
    border-radius: ${themeGet('border.standard.radius')};

    box-shadow: ${({ $showShadow }) =>
        $showShadow && themeGet('boxShadow.card')};

    flex-grow: ${({ $grow }) => $grow && '1'};

    .ant-card-body {
        height: ${({ $fill }) => $fill && '100%'};
        padding: ${({ $padding }) =>
            $padding ? `${$padding}` : themeGet('padding.card')};
    }
`;
